import http from '@/utils/request';

// 待审核收款统计
export const getFinReceiptWorkBenchCount = (data) => {
  return http.post({
    url: '/receipt/receipt/finReceiptWorkBenchCount',
    data,
  });
};

// 待审核付款统计
export const getFinPaymentWorkBenchCount = (data) => {
  return http.post({
    url: '/payment/payment/finPaymentWorkBenchCount',
    data,
  });
};
